import React from "react";
import moment from 'moment';
import { Link,Redirect } from "react-router-dom";
import {getData} from '../../services/index';
import { Tabs ,Modal} from 'antd';
import { StickyContainer, Sticky } from 'react-sticky';
import 'antd/dist/antd.css';

const { TabPane } = Tabs;

class Index extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			loading: false,
			visible: false,
		}
		this.logout = this.logout.bind(this);
	}

	componentWillMount() {
		document.querySelector(".loader-wrapper").style = "display: none";
		setTimeout(() => {
			document.querySelector(".loader-wrapper").style = "display: none";
		}, 500);
		if(!localStorage.getItem('schoolData')) {
			localStorage.setItem("schoolData",'');
			localStorage.clear();
			window.location.href = '/login';
		}
	}
	
	showModal = () => {
		this.setState({
		  visible: true,
		});
	  };

	  handleOk = () => {
		this.setState({ loading: true });
		setTimeout(() => {
		  this.setState({ loading: false, visible: false });
		}, 3000);
	  };

	  handleCancel = () => {
		this.setState({ visible: false });
	  };
	  
	  logout(){
			localStorage.setItem("schoolData",'');
			localStorage.clear();
			window.location.href = '/login/';
		}

	render() {
	
	const { visible, loading } = this.state;	
		return (
			<div>
			<div class="school_bg">
				<h2>Good Morning</h2>
				<h3>Web Work School</h3>
				
				<a href="javascript:void(0)" class="upcoming_holidays">Upcoming Holidays
				<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="24" height="24"><path fill="none" d="M0 0h24v24H0z"/><path d="M13.172 12l-4.95-4.95 1.414-1.414L16 12l-6.364 6.364-1.414-1.414z" fill="rgba(0,112,255,1)"/></svg>
				</a>
			</div>
			
      
      <div id="main">		
         <div class="row mobile setting">
		 
		<div class="col s12 m12 ex-padd">
            <div id="breadcrumbs-wrapper" class="bg-off">
               <div class="">
                  <div class="row no-margin">
				  <div class="col s12 m12 header-title mt-20 mh-40 iq-card">
                     <div class="col s12 m6 l6 pt-10">
                        <h5 class="breadcrumbs-title"><span>Setting</span></h5>
                     </div>
                     <div class="col s12 m6 l6 right-align-md pt-10">
                        <ol class="breadcrumbs mb-0">
                           <li class="breadcrumb-item"><a href="/">Home</a>
                           </li>
                           <li class="breadcrumb-item active">Setting
                           </li>
                        </ol>
                     </div>
                     </div>
                  </div>
               </div>
            </div>
            </div>
		 
		 
            <div class="col s12 col-xs-12 pd0 home">
               <div class="container">
                  <div class="section">
                     <div>
					 
	<div class="row">
   <div class="col s12 m12">
      <div class="iq-card card">
         <div class="iq-card-header d-flex justify-content-between">
            <div class="card-title card-title inverted-border-radius">
               <h4 class="card-title mb-0">Settings</h4>
            </div>
         </div>
         <div class="iq-card-body card-body row pt-0">
            <div class="col s12 borders pd7">
				<div class="col5 s12 col-xs-4 m3">
                  <div class="card gradient-shadow gradient-45degs-green-teal border-radius-20 animate fadeUp">
                     <Link to={`${process.env.PUBLIC_URL}/settings/fees`}>
                     <div class="card-content center">
                        <img src="assets/icons/shipping.png"
                           class="width-33 border-rounds z-depth-5s responsive-img" alt="image" />
                        <h5 class="white-text lighten-4">Fees Setting</h5>
                        
                     </div>
                     </Link>
                  </div>
               </div>
			   
			   
			   
               
            </div>
         </div>
      </div>
   </div>
</div>	 


                     </div>
                  </div>
               </div>
            </div>
            <div class="content-overlay"></div>       
      </div>
      </div>
     

			</div>
		) 
	} 
}
export default Index;
